<template>
<el-dialog v-model="showDialog" width="540px" append-to-body z-index="9999" style="border-radius: 10px;" :lock-scroll="false">
  <div class="about-me-warpper">
    <div class="header text-center">
      <user-header-img :width="60" font-size="40px"
                       :text="studentInfo?.englishName ? studentInfo?.englishName.slice(0,1) : ''"
                       style="margin:30px auto 12px"/>
      <div class="userName font-bold">{{studentInfo?.englishName || ''}}</div>
    </div>
    <div class="content" style="margin-top:40px;">
      <h4 class="font-bold color-blue" style="margin:30px 0;">Details</h4>
      <div class="flex items-center justify-start user-label">
        <div class="icon-warp flex items-center justify-between">
          <cam-icons name="userLine" class="inline-icon" :size="14" style="flex: 0 0 40px"/>
          <div class="label-name flex-1 color-blue">Student ID</div>
        </div>
        <div class="flex-1">
          {{studentInfo?.syncStudentId || ''}}
        </div>
      </div>

      <div class="flex items-center justify-start user-label">
        <div class="icon-warp flex items-center justify-between">
          <cam-icons name="profileLine" class="inline-icon" :size="14" style="flex: 0 0 40px"/>
          <div class="label-name flex-1 color-blue">AD Account</div>
        </div>
        <div class="flex-1">
          {{studentInfo?.syncAdAccount || ''}}
        </div>
      </div>

      <div class="flex items-center justify-start user-label">
        <div class="icon-warp flex items-center justify-between">
          <cam-icons name="stackLine" class="inline-icon" :size="14" style="flex: 0 0 40px"/>
          <div class="label-name flex-1 color-blue">Programme</div>
        </div>
        <div class="flex-1">
          {{studentInfo?.syncRouNameEn || studentInfo?.syncRouNameCn}}
        </div>
      </div>

      <div class="flex items-center justify-start user-label">
        <div class="icon-warp flex items-center justify-between">
          <cam-icons name="mailLine" class="inline-icon" :size="14" style="flex: 0 0 40px"/>
          <div class="label-name flex-1 color-blue">Email</div>
        </div>
        <div class="flex-1">
          {{studentInfo?.email || ''}}
        </div>
      </div>
    </div>
  </div>
</el-dialog>
</template>
<script setup>
import { ref, defineProps, defineEmits, computed, toRefs } from 'vue'
import UserHeaderImg from '@/layout/components/UserHeaderImg.vue'
import UserStore from '@/stores/User.js'
import CamIcons from '@/components/CamIcons/index.vue'
const useUserStore = UserStore()
const studentInfo = computed(() => useUserStore.studentInfo)
const props = defineProps({
  modelValue: {
    type: Boolean,
    'default': false,
  },
})
const emits = defineEmits(['update:modelValue'])
const showDialog = computed({
  get() {
    return props.modelValue
  },
  set(val) {
    emits('update:modelValue', val)
  },
})

</script>
<style scoped lang="scss">
.about-me-warpper{
  width:360px;
  margin:0 auto;
}
.icon-warp{
  flex: 0 0 200px;
}
.color-blue{
  color: var(--cam-color-blue);
}
.user-label{
  margin-bottom: 30px;
}
.label-name{
  position: relative;
  &:after{
    position: absolute;
    content: '';
    width: 1px;
    height: 80%;
    background-color: var(--cam-color-blue);
    left: -8px;
    top:2px;
  }
}
.userName{
  margin-top:22px;
}
</style>
